import "src/decidim/meetings/meetings";
import "src/decidim/forms/forms";
require.context("../images", true);
import "stylesheets/decidim/meetings/meetings.scss";
